import React, { useContext } from "react";
import styled from "styled-components";

import { CurrentThemeContext } from "./../common/ThemeContextWrapper";
import { ShowLandingContext } from "./../Landing/ShowLandingContextWrapper";
import { HideUIContext } from "./../common/ToggleHideUIContextWrapper";

import Landing from "./../Landing/Landing";
import HeaderImage from "./HeaderImage";

const Header = styled.header`
    align-items: center;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: ${props => props.theme.tabletCutoffWidth + 1}px;
    top: ${props => props.showLanding ? "40vh" : "30px"};
    position: absolute;
    left: ${props => props.isVoidTheme && !props.showLanding ? "0" : "50vw"};
    margin-left: ${props => props.isVoidTheme && !props.showLanding ? "250px" : "-240px"};
    transition-duration: ${props => props.theme.landingTransitionDuration}s;
    transition-property: top, left, margin-left;
    z-index: 30;

    @media print {
        display: none;
    }

    @media only screen and (max-width: ${props => props.theme.mobileCutoffWidth}px) {
        margin-left: 0;
        left: 0;
        width: 100vw;
        top: 10px;
    }
`;

Header.displayName = "Header";

const HeaderText = styled.h1`
    display: none;
`;

HeaderText.displayName = "HeaderText";

function MainHeader() {
    const { showLanding } = useContext(ShowLandingContext);
    const { currentTheme } = useContext(CurrentThemeContext);
    const hideUI = useContext(HideUIContext);

    return (
        <Header
            className={hideUI ? "hide-ui" : ""}
            showLanding={showLanding}
            isVoidTheme={currentTheme === "lvoid" || currentTheme === "dvoid"}
        >
            <HeaderImage />
            <HeaderText>
                RetroGrade Minis Tabletop Miniatures
            </HeaderText>
            {showLanding ?
                <Landing /> : null
            }
        </Header>
    );
}

export default MainHeader;
